<template>
  <div>
    <div class="chart-bar-top">
      <div class="chart-card-top">
        <div class="card-title">
          <div>全省工商联发展情况</div>
        </div>
        <div class="card-content">
          <div class="flex-between">
            <TabList :list="tabList" :act="tabIndex" @clickItem="changeTab" />
<!--            <RichText v-model="richText"></RichText>-->
<!--            <div class="rich-text" v-html="richText"></div>-->

          </div>
<!--          <div class="ql-container ql-snow">-->
<!--            <div class="rich-text ql-editor" v-html="richText"></div>-->
<!--          </div>-->
          <div class="rich-text ql-editor" v-html="richText"></div>
        </div>
      </div>
    </div>
    <div class="chart-bar">
      <el-carousel height="100%" :autoplay="false" style="width: 100%;height: 100%" arrow="never">
        <el-carousel-item autoplay="false">
          <div class="chart-card">
            <div class="card-item l2-1">
              <div class="card-title">
                <div>广东省工商联组织概况</div>
              </div>
              <div class="card-content">
                <div class="flex-between">
                  <div>
                    <!-- <span id="btn-link" @click="handleLink(6)">关联地图展示</span> -->
                  </div>
                  <ElementSelect
                      :val="orgProfileYear"
                      :options="orgProfileYearList"
                      @change="
                (e) => {
                  orgProfileYear = e;
                }
              "
                  />
                </div>
                <OrganizationProfile
                    ref="PrivateMigrate"
                    title="广东省万企兴万村行动开展情况"
                    name="privateTax"
                    apiName="getPrivateTax"
                    type="multi"
                    showLabel
                    :yearP="orgProfileYear"
                    @showModal="showModal"
                />
              </div>
            </div>
            <div class="card-item l2-2">
              <div class="card-title">
                <div>全省工商联工作人员情况</div>
              </div>
              <div class="card-content national-staff-position-chart">
                <div class="flex-between">
                  <div>
                  </div>
                  <ElementSelect
                      :val="nationalStaffPositionSelectYear"
                      :options="nationalStaffPositionYear"
                      @change="
                    (e) => {
                      nationalStaffPositionSelectYear = e;
                      if(nationalStaffPositionSelectYear){
                        getNationalStaffPosition();
                      }
                    }
                  "
                  />
                </div>
                <v-chart ref="national-staff-position-year-chart"
                         id="nationalStaffPositionYearChart"
                         class="nationalStaffPositionYearChart"
                         :options="nationalStaffPositionYearChartOption" width="100%"/>
              </div>
            </div>

          </div>
        </el-carousel-item>
        <el-carousel-item autoplay="false">
          <div class="chart-card">
            <div class="card-item">
              <div class="card-title">
                <div>工商联执常委分类统计</div>
              </div>
              <div class="card-content">
                <div class="filter-box">
                  <ElementSelect
                      :val="executiveCommitteeClassifiedStatisticsSelectCity"
                      :options="executiveCommitteeClassifiedStatisticsCity"
                      @change="
                  (e) => {
                    executiveCommitteeClassifiedStatisticsSelectCity = e;
                    getExecutiveCommitteeClassifiedStatistics();
                  }
                "
                      class="ml12"
                  />
                  <ElementSelect
                      :val="executiveCommitteeClassifiedStatisticsSelectType"
                      :options="executiveCommitteeClassifiedStatisticsType"
                      @change="
                  (e) => {
                    executiveCommitteeClassifiedStatisticsSelectType = e;
                    if(executiveCommitteeClassifiedStatisticsSelectType === 1){
                      executiveCommitteeClassifiedStatisticsChartData = educationalBackgroundChartData
                    } else if (executiveCommitteeClassifiedStatisticsSelectType === 2){
                      executiveCommitteeClassifiedStatisticsChartData = ageGroupChartData
                    } else {
                      executiveCommitteeClassifiedStatisticsChartData = politicalStatusChartData
                    }
                  }
                "
                      class="ml12 long-select"
                  />
                </div>
                <DisaggregatedStatistical ref="executiveCommitteeClassifiedStatistics"
                                          :search-data="executiveCommitteeClassifiedStatisticsChartData" :show-index="1"
                                          chart-name="executiveCommitteeClassifiedStatistics"/>
              </div>
            </div>
            <div class="card-item l2-2">
              <div class="card-title">
                <div>工商联执常委履职评价情况</div>
              </div>
              <div class="card-content">
                <div class="filter-box">
                  <ElementSelect
                      :val="performanceEvaluationSituationSelectYear"
                      :options="performanceEvaluationSituationYear"
                      @change="
                  (e) => {
                    performanceEvaluationSituationSelectYear = e;
                    getPerformanceEvaluationSituation();
                  }
                "
                      class="ml12"
                  />
                  <ElementSelect
                      :val="performanceEvaluationSituationSelectIdentity"
                      :options="performanceEvaluationSituationIdentity"
                      @change="
                  (e) => {
                    performanceEvaluationSituationSelectIdentity = e;
                    getPerformanceEvaluationSituation();
                  }
                "
                      class="ml12 long-select"
                  />
                </div>
                <PerformanceEvaluationSituation ref="performanceEvaluationSituation"
                                                :search-data="performanceEvaluationSituationChartData" :show-index="1"
                                                chart-name="performanceEvaluationSituation"
                                                @click-chart="handleClickChart($event)"/>
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <EleDialog id="performance_evaluation_situation_detail" title="工商联执常委履职评价详情"
               :visible.sync="performanceEvaluationSituationDetailShow"
               class="performance-evaluation-situation-detail" width="20%">
      <span class="text_211">履职评价等级：{{ performanceEvaluationSituationChartSelect }}</span>
      <el-table
          :data="performanceEvaluationSituationTableData"
          style="width: 100%;margin-bottom: 20px;overflow:unset"
          row-key="standing_committee_member_name"
          border
          default-expand-all
          height="60%"
          :header-cell-style="{textAlign: 'center'}"
          :cell-style="{ textAlign: 'center' }"
          @cell-click="performanceEvaluationSituationTableCellClick">
        <el-table-column
            prop="standing_committee_member_name"
            label="姓名">
        </el-table-column>
        <el-table-column
            prop="enterprise_registered_name"
            label="所属企业">
        </el-table-column>
      </el-table>
    </EleDialog>
    <EleDialog id="org_dev" title="全省各级工商联组织发展情况" :visible.sync="showOrgDev" width="30%"
               class="org-dev">
      <el-row :gutter="20">
        <div class="item-label">
          全省各级工商联组织数: <b>{{orgDev.total || '-'}}</b>
        </div>

      </el-row>
      <el-row :gutter="20" style="padding-top: 10px">
        <div class="sub-title">
          <span>县级以上工商联设立情况</span>
        </div>
      </el-row>
      <el-row :gutter="20" style="padding-top: 10px; padding-left: 10px">
        <el-col :span="6">
          <div class="item-label">
            省级工商联
          </div>
        </el-col>

        <el-col :span="8">
          <div class="item-label">
            地级以上市工商联
          </div>
        </el-col>
        <el-col :span="10">
          <div class="item-label">
            县级工商联
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20" style="padding-top: 10px; padding-left: 10px">
        <el-col :span="6">
          <div class="item-label cursor-pointer" @click="getOrgInfoData(0, true)">
            {{orgDev.province_industry_commerce_federation_ || '-'}} 个
          </div>
        </el-col>
        <el-col :span="8">
          <div class="item-label cursor-pointer" @click="getOrgInfoData(1, true)">
            {{orgDev.above_prefecture_level_amount || '-'}} 个
          </div>
        </el-col>
        <el-col :span="10">
          <div class="item-label cursor-pointer"  @click="getOrgInfoData(2, true)">
            {{orgDev.county_amount || '-'}} 个<span
              class="comment-font"> (含功能区工商联)
          </span>
          </div>
        </el-col>
      </el-row>
    </EleDialog>
    <EleDialog id="org_info" title="工商联组织详情" :visible.sync="orgInfoShow" class="org-info">
      <el-row>
        <el-col :span="5">
          <div class="item-label text-align-right">
            组织名称
          </div>
        </el-col>
        <el-col :span="7" style="padding-left: 10px">
          <div class="item-label">
            {{orgInfo.organization_name || '-'}}
          </div>
        </el-col>
        <el-col :span="5">
          <div class="item-label text-align-right">
            上级组织名称
          </div>
        </el-col>
        <el-col :span="7" style="padding-left: 10px">
          <div class="item-label">
            {{orgInfo.parent_organization_name || '-'}}
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">
          <div class="item-label text-align-right">
            机构编码
          </div>
        </el-col>
        <el-col :span="7" style="padding-left: 10px">
          <div class="item-label">
            {{orgInfo.organization_code || '-'}}
          </div>
        </el-col>
        <el-col :span="5">
          <div class="item-label text-align-right">
            录入年份
          </div>
        </el-col>
        <el-col :span="7" style="padding-left: 10px">
          <div class="item-label">
            {{orgInfo.data_year || '-'}}
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">
          <div class="item-label text-align-right">
            行政级别
          </div>
        </el-col>
        <el-col :span="7" style="padding-left: 10px">
          <div class="item-label">
            {{orgInfo.administrative_level || '-'}}
          </div>
        </el-col>
        <el-col :span="5">
          <div class="item-label text-align-right">
            电子邮箱
          </div>
        </el-col>
        <el-col :span="7" style="padding-left: 10px">
          <div class="item-label">
            {{orgInfo.email || '-'}}
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">
          <div class="item-label text-align-right">
            联系电话
          </div>
        </el-col>
        <el-col :span="7" style="padding-left: 10px">
          <div class="item-label">
            {{orgInfo.phone || '-'}}
          </div>
        </el-col>
        <el-col :span="5">
          <div class="item-label text-align-right">
            传真
          </div>
        </el-col>
        <el-col :span="7" style="padding-left: 10px">
          <div class="item-label">
            {{orgInfo.fax || '-'}}
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">
          <div class="item-label text-align-right">
            邮编
          </div>
        </el-col>
        <el-col :span="7" style="padding-left: 10px">
          <div class="item-label">
            {{orgInfo.postal_code || '-'}}
          </div>
        </el-col>
        <el-col :span="5">
          <div class="item-label text-align-right">
            通讯地址
          </div>
        </el-col>
        <el-col :span="7" style="padding-left: 10px">
          <div class="item-label">
            {{orgInfo.communication_address || '-'}}
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">
          <div class="item-label text-align-right">
            本级直属个人会员数
          </div>
        </el-col>
        <el-col :span="7" style="padding-left: 10px">
          <div class="item-label">
            {{orgInfo.personal_member_amount || '-'}}
          </div>
        </el-col>
        <el-col :span="5">
          <div class="item-label text-align-right">
            本级直属企业会员数
          </div>
        </el-col>
        <el-col :span="7" style="padding-left: 10px">
          <div class="item-label">
            {{orgInfo.company_member_amount || '-'}}
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">
          <div class="item-label text-align-right">
            本级直属团体会员数
          </div>
        </el-col>
        <el-col :span="7" style="padding-left: 10px">
          <div class="item-label">
            {{orgInfo.groups_member_amount || '-'}}
          </div>
        </el-col>
        <el-col :span="5">
          <div class="item-label text-align-right">
            本级直属会员总数
          </div>
        </el-col>
        <el-col :span="7" style="padding-left: 10px">
          <div class="item-label">
            {{orgInfo.under_same_level_member_amount || '-'}}
          </div>
        </el-col>
      </el-row>
    </EleDialog>
    <EleDialog id="org_list" :title="orgListTitle" :visible.sync="orgInfoListShow">
      <div class="filter-box">
        <ElementSelect
            :val="parentName"
            :options="parentSelectList"
            @change="
              (e) => {
                parentName = e;
                searchName = '';
                if(e){
                  let conData =
                  parentSelectList.filter((item) => item.value === e)[0].children;
                  this.searchNameSelectList = conData
                } else {
                  this.searchNameSelectList = []
                }
                getOrgInfoData(selectIndex, false);
              }
            "
            size="middle"
            v-if="selectIndex === 2"
            clearable
        />
        <ElementSelect
            :val="searchName"
            :options="searchNameSelectList"
            @change="
              (e) => {
                searchName = e;
                getOrgInfoData(selectIndex, false);
              }
            "
            size="middle"
            v-if="selectIndex === 1 || selectIndex === 2"
            clearable
        />
      </div>
      <el-table
          :data="orgInfoList"
          style="width: 100%;margin-bottom: 20px;;overflow:unset"
          row-key="organization_name"
          border
          default-expand-all
          :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
          height="60%"
          @cell-click="orgListCellClick">
        <el-table-column
            prop="organization_name"
            label="工商联名称">
        </el-table-column>
        <el-table-column
            prop="phone"
            label="联系电话">
        </el-table-column>
        <el-table-column
            prop="fax"
            label="传真">
        </el-table-column>
        <el-table-column
            prop="email"
            label="电子邮箱">
        </el-table-column>
        <el-table-column
            prop="communication_address"
            label="通讯地址"
            width="180">
        </el-table-column>
      </el-table>
    </EleDialog>
    <EleDialog id="member_dev" title="全省工商联会员发展情况" :visible.sync="memberDevInfoShow"
               class="member-dev" height="100%">
      <el-row :gutter="20" style="padding-left: 10px">
        <el-col :span="6">
          <div class="item-label">
            企业会员
          </div>
          <div class="item-label" style="padding-top: 10px">
            {{ memberDevelopmentData.company_member_amount || '-' }} 个
          </div>
        </el-col>

        <el-col :span="6">
          <div class="item-label">
            团体会员
          </div>
          <div class="item-label" style="padding-top: 10px">
            {{ memberDevelopmentData.groups_member_amount || '-' }} 个
          </div>
        </el-col>
        <el-col :span="6">
          <div class="item-label">
            个人会员
          </div>
          <div class="item-label" style="padding-top: 10px">
            {{ memberDevelopmentData.personal_member_amount || '-' }} 个
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20" style="">
        <div class="sub-title">
          <span>工商联会员数量位居前五的地市</span>
        </div>
      </el-row>
      <el-row :gutter="20" style="padding-left: 10px">
        <el-col :span="4" v-for="item in memberTopFiveData">
          <div class="item-label">
            {{ item.city || '-' }}
          </div>
          <div class="item-label" style="padding-top: 10px">
            {{ item.member_amount || '-' }} 个
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20" style="">
        <div class="sub-title">
          <span>工商联会员增幅前三的地市</span>
        </div>
      </el-row>
      <el-row :gutter="20" style="padding-left: 10px">
        <el-col :span="6" v-for="item in memberGrowthTopThreeData">
          <div class="item-label">
            {{ item.city || '-' }}
          </div>
          <div class="item-label"  style="padding-top: 10px">
            {{ item.growth || '-' }} %
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20" style="">
        <div class="sub-title">
          <span>各地市近3年会员变化情况</span>
        </div>
        <div class="flex-between">
          <TabList :list="memberChangeTabList" :act="memberChangeTabIndex"
                   @clickItem="memberChangeTab" />
          <ElementSelect
              :val="selectMemberChangeThreeYearsCity"
              :options="memberChangeThreeYearsCity"
              @change="
              (e) => {
                selectMemberChangeThreeYearsCity = e;
                getOrgMemberChangeThreeYears();
              }
            "
              size="middle"
          />
        </div>
        <v-chart ref="orgMemberChangeThreeYearsBarChart" id="orgMemberChangeThreeYearsChart"
                 class="bar-chart"
                 :options="memberChangeThreeYearsCityChartOption" width="100%"/>
      </el-row>
    </EleDialog>
    <EleDialog id="worker_list" title="市、县工商联编制人数情况" :visible.sync="workerListShow">
      <div class="filter-box">
        <ElementSelect
            :val="cityEPersonSelectCity"
            :options="cityEPersonCityList"
            @change="
              (e) => {
                cityEPersonSelectCity = e;
                getCityEPerson();
              }
            "
            size="middle"
            clearable
        />
      </div>
      <el-table
          :data="cityEPersonList"
          style="width: 100%;margin-bottom: 20px;overflow:unset"
          row-key="city"
          border
          default-expand-all
          height="60%">
        <el-table-column
            prop="city"
            label="地市">
        </el-table-column>
        <el-table-column
            prop="county_federation_amount"
            label="县级工商联数">
        </el-table-column>
        <el-table-column
            prop="city_actual_worker_amount"
            label="市级实际工作人数">
        </el-table-column>
        <el-table-column
            prop="county_actual_worker_amount"
            label="县级实际工作总人数">
        </el-table-column>
        <el-table-column
            prop="county_avg_worker_amount"
            label="县级平均工作人数">
        </el-table-column>
        <el-table-column
            prop="city_preparation_worker_amount"
            label="市级编制人数">
        </el-table-column>
        <el-table-column
            prop="county_preparation_worker_amount"
            label="县级编制总人数">
        </el-table-column>
        <el-table-column
            prop="county_avg_preparation_amount"
            label="县级平均编制人数">
        </el-table-column>
      </el-table>
    </EleDialog>
    <EleDialog id="five_good_list" title="“五好”工商联各地市情况" :visible.sync="fiveGoodListShow"
               class="five-good">
      <el-row :gutter="20" style="padding-left: 10px">
        <el-col :span="12">
          <div class="item-label">
            全国“五好”县级工商联数：<b>{{ nationalFiveGoodTotal || '-' }}</b>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="item-label">
            省“五好”县级工商联数：<b>{{ provincesFiveGoodTotal || '-' }}</b>
          </div>
        </el-col>
      </el-row>
      <div class="flex-between" style="padding-top: 10px; padding-bottom: 10px;">
        <TabList :list="fiveGoodTabList" :act="fiveGoodTabIndex" @clickItem="fiveGoodChangeTab"/>
        <div></div>
      </div>
      <el-table
          :data="showFiveTableList"
          style="width: 100%;margin-bottom: 20px;overflow:unset"
          row-key="city"
          border
          default-expand-all
          height="60%">
        <el-table-column
            prop="city"
            label="地市" min-width="100">
        </el-table-column>
        <el-table-column
            prop="county"
            label="区县" min-width="200">
        </el-table-column>
        <el-table-column
            prop="amount"
            label="数量" min-width="80">
        </el-table-column>
        <el-table-column
            prop="proportion"
            label="占比" min-width="80">
        </el-table-column>
      </el-table>
    </EleDialog>
    <EleDialog id="coc_change_three_year" title="各地级以上市近3年镇街商会变化情况"
               :visible.sync="cocChangeThreeYearInfoShow"
               class="coc-change-three-year" height="100%">
      <el-row :gutter="20" style="">
        <div class="flex-between">
          <div class="sub-title">
            <span>近3年镇街商会数</span>
          </div>
          <ElementSelect
              :val="selectCocChangeThreeYearsCity"
              :options="cocChangeThreeYearsCity"
              @change="
              (e) => {
                selectCocChangeThreeYearsCity = e;
                getCocChangeThreeYear();
              }
            "
              size="middle"
          />
        </div>
        <v-chart ref="bar-chart" id="cocChangeThreeYearChart" class="bar-chart"
                 :options="cocChangeThreeYearChartOption" width="100%"/>
      </el-row>
      <el-row :gutter="20" style="">
        <div class="sub-title">
          <span>近3年镇街商会覆盖率</span>
        </div>
        <ComTable
            :tableCol="cocChangeThreeYearCoverTableCol"
            :tableData="cocChangeThreeYearCoverTableData"
            :isPagination="false"
            style="height: 150px"
        />
      </el-row>
    </EleDialog>
    <EleDialog :title="dialogTitle" :visible.sync="showDialog" :class="itemIndex === 2 && 'info-modal'">
      <!--      <template v-if="itemIndex === 2">-->
      <!--        <div class="item-title" :data-title="curData.c_entname"></div>-->
      <!--        <div class="item-content flex-between">-->
      <!--          <ul class="content-ul" v-for="ul in dialogUlList">-->
      <!--            <li v-for="li in ul">-->
      <!--              <div class="li-label">{{ li.label }}</div>-->
      <!--              <div class="li-value">{{ itemData[li.key] }}</div>-->
      <!--            </li>-->
      <!--          </ul>-->
      <!--        </div>-->
      <!--      </template>-->
      <div v-if="itemIndex === 2" class="item-title" data-title="项目月报"></div>
      <div v-else class="filter-box">
        <!--        <ElementSelect-->
        <!--          :val="search.city"-->
        <!--          :options="optionCity"-->
        <!--          @change="-->
        <!--            (e) => {-->
        <!--              search.city = e;-->
        <!--              refreshPage();-->
        <!--            }-->
        <!--          "-->
        <!--          size="middle"-->
        <!--        />-->
        <!--        <EleInput v-model="search.entName" placeholder="请输入企业名称" clearable />-->
      </div>
      <!--      <ComTable-->
      <!--        :tableCol="tableCol"-->
      <!--        :tableData="tableData"-->
      <!--        :pager="pager"-->
      <!--        @handleSizeChange="handleSizeChange"-->
      <!--        @handleCurrentChange="handleCurrentChange"-->
      <!--        :isPagination="itemIndex !== 2"-->
      <!--      />-->
    </EleDialog>
    <EleDialog title="企业概况" :visible.sync="showCompany" class="company-profile">
      <CompModal v-if="showCompany" :curData="curData"></CompModal>
    </EleDialog>
    <div></div>
  </div>
</template>

<script>
import drawBar from '../chartJs/chartBarAndLine.js';
import drawBar2 from '../chartJs/chartLicense';
import drawBar3 from '../chartJs/chartPrivateTaxes';
import drawOneBar from '../chartJs/bar';
// import drawAnyBar from '../chartJs/bar';
import drawAnyBar from '../chartJs/rotateBar';
import FinancialService from './FinancialService.vue';
import OrganizationProfile from './OrganizationProfile.vue';
import ComTable from '../../../components/ComTable';
import CompModal from './CompModal.vue';
import TabList from '../../../components/tabList';
import MarketSubjectType from './MarketSubjectType';
import MarketMainIndustry from './MarketMainIndustry.vue';
import ElementSelect from '../../../components/element-select';
import RichText from '../../../components/RichText';
import cityJson from '../cityJson';
import { getTime } from '@/utils/tool';
import ProvinceWorkerCase from './ProvinceWorkerCase';

import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import "@/styles/quill-editor.css";


import DisaggregatedStatistical from './DisaggregatedStatistical';
import PerformanceEvaluationSituation from './PerformanceEvaluationSituation';
import echarts from "echarts";
import drawPie3D from "@/views/home/chartJs/pie3D";
import drawPie from "@/views/home/chartJs/pie";
export default {
  name: 'MemberLeft',
  components: { ElementSelect, ComTable, TabList, MarketSubjectType, MarketMainIndustry,
    CompModal, FinancialService, RichText, OrganizationProfile,
    DisaggregatedStatistical,ProvinceWorkerCase,PerformanceEvaluationSituation },
  props: {
    yearP: {
      type: Number,
      default: 2024,
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      orgProfileYearList: [],
      orgProfileYear: null,
      nationalStaffPositionYear: [],
      nationalStaffPositionSelectYear: '',
      nationalStaffPositionYearChartOption: [],
      executiveCommitteeClassifiedStatisticsCity: [],
      executiveCommitteeClassifiedStatisticsSelectCity: '',
      executiveCommitteeClassifiedStatisticsType: [
        {
          value: 0,
          label: '政治面貌占比',
        },
        {
          value: 1,
          label: '学历占比',
        },
        {
          value: 2,
          label: '年龄段分布',
        },
      ],
      executiveCommitteeClassifiedStatisticsSelectType: 0,
      executiveCommitteeClassifiedStatisticsChartData: [],
      politicalStatusChartData: [],
      educationalBackgroundChartData: [],
      ageGroupChartData: [],
      performanceEvaluationSituationYear: [],
      performanceEvaluationSituationSelectYear: '',
      performanceEvaluationSituationIdentity: [],
      performanceEvaluationSituationSelectIdentity: '',
      performanceEvaluationSituationChartData: [],
      performanceEvaluationSituationChartOption:[],
      richText: "",
      tabList: [
        {
          key: 1,
          label: '工商联地方组织发展情况',
        },
        {
          key: 2,
          label: '工商联商会发展情况',
        },
        {
          key: 3,
          label: '工商联会员组织发展情况',
        },
      ],
      tabIndex: 0,
      richTextActiveName: 1,
      performanceEvaluationSituationDetailShow: false,
      performanceEvaluationSituationTableData: [],
      performanceEvaluationSituationChartSelect: null,

      // OrganizationProfile dialog参数
      showOrgDev: false,
      orgDev: {},
      orgInfo: {},
      orgInfoList: [],
      orgInfoShow: false,
      orgInfoListShow: false,
      selectIndex: 0,
      parentSelectList: [],
      searchNameSelectList: [],
      parentName: '',
      searchName: '',
      orgListTitle: '',
      memberDevInfoShow: false,
      memberChangeThreeYearsCity: [],
      selectMemberChangeThreeYearsCity: '',
      memberChangeThreeYearsList: [],
      memberGrowthTopThreeData: {},
      memberTopFiveData: {},
      memberDevelopmentData: {},
      memberChangeTabList: [
        {
          key: 0,
          label: '个人'
        },
        {
          key: 1,
          label: '企业'
        },
        {
          key: 2,
          label: '团体'
        }
      ],
      memberChangeTabIndex: 0,
      memberChangeThreeYearsCityChartOption: null,
      workerListShow: false,
      cityEPersonSelectCity: '',
      cityEPersonCityList: [],
      cityEPersonList: [],
      nationalFiveGoodList: [],
      nationalFiveGoodTotal: null,
      provincesFiveGoodList: [],
      provincesFiveGoodTotal: null,
      fiveGoodListShow: false,
      showFiveTableList: [],
      fiveGoodTabList: [
        {
          key: 0,
          label: '全国“五好”县级工商联'
        },
        {
          key: 1,
          label: '广东省“五好”县级工商联'
        }
      ],
      fiveGoodTabIndex: 0,
      cocChangeThreeYearInfoShow: false,
      cocChangeThreeYearChartOption: null,
      selectCocChangeThreeYearsCity: '',
      cocChangeThreeYearsCity: [],
      cocChangeThreeYearsList: [],

    };
  },
  created() {
    this.getMemberScreenRichtext();
    this.getOrgProfileYear();
    this.getNationalStaffPositionYear();
    this.getExecutiveCommitteeClassifiedStatisticsCity();
    this.getPerformanceEvaluationSituationYear();
    this.getPerformanceEvaluationSituationIdentity();

  },
  computed: {
    cocChangeThreeYearCoverTableCol() {
      if (this.cocChangeThreeYearsList) {
        let arr = [];
        for (let i = 0; i < this.cocChangeThreeYearsList.length; i++) {
          let col = {
            label: this.cocChangeThreeYearsList[i].year,
            param: this.cocChangeThreeYearsList[i].year,
          }
          arr.push(col);
        }
        return arr;
      }
    },
    cocChangeThreeYearCoverTableData() {
      if (this.cocChangeThreeYearsList) {
        let arr = [];
        let col = {};
        for (let i = 0; i < this.cocChangeThreeYearsList.length; i++) {
          col[this.cocChangeThreeYearsList[i].year] =
              this.cocChangeThreeYearsList[i].proportion + '%';
        }
        arr.push(col);
        return arr;
      }
    }
  },
  watch: {

  },
  methods: {
    performanceEvaluationSituationTableCellClick(row,column,event,cell){
      this.$emit('changeCenterPersonName', row.standing_committee_member_name);
      this.performanceEvaluationSituationDetailShow = false;
    },
    getPerformanceEvaluationSituationTableData(){
      this.performanceEvaluationSituationTableData = []
      this.$api.member
          .getPerformanceEvaluationSituationTableData({
            year: this.performanceEvaluationSituationSelectYear,
            standingCommitteeIdentity: this.performanceEvaluationSituationSelectIdentity,
            evaluationGrade: this.performanceEvaluationSituationChartSelect
          }).then((res) => {
        if (res.data.data){
          this.performanceEvaluationSituationTableData = res.data.data;
          this.performanceEvaluationSituationDetailShow = true;
        }
      });
    },
    handleClickChart(params) {
      this.performanceEvaluationSituationChartSelect = params.seriesName;
      this.getPerformanceEvaluationSituationTableData();
    },
    getMemberScreenRichtext(){
      this.richText = '';
      this.$api.member
          .getMemberScreenRichtext({type: this.richTextActiveName}).then((res) => {
        if (res.data.data){
          this.richText = res.data.data.richtext;
        }
      });
    },
    getOrgProfileYear(){
      this.$api.member
          .getOrgProfileYear().then((res) => {
            // this.orgProfileYearList = res.data.data;
            if (res.data.data){
              this.orgProfileYearList = res.data.data.map((item) => {
                return {
                  label: item,
                  value: item
                }
              });
              this.orgProfileYear = res.data.data[0]
            }
          });
    },
    getNationalStaffPositionYear(){
      this.$api.member
          .getNationalStaffPositionYear().then((res) => {
        if (res.data.data){
          this.nationalStaffPositionYear = res.data.data.map((item) => {
            return {
              label: item,
              value: item
            }
          });
          this.nationalStaffPositionSelectYear = res.data.data[0];
          this.getNationalStaffPosition()
        }
      });
    },
    getNationalStaffPosition() {
      this.$api.member.getNationalStaffPosition({ year: this.nationalStaffPositionSelectYear }).then((res) => {
        let { data } = res.data;
        let names = ['实际工作人数', '编制人数'];
        let list = {
          yAxis: {
            names: ['单位：名'],
          },
          names: Array.from(names),
          data: [],
        };
        list.names = names;
        list.showLabel = true;
        if (data) {
          for (let i = 0; i < data.length; i++) {
            if (data[i].city){
              let obj = {};
              obj['城市'] = (data[i].city);
              obj['实际工作人数'] = (data[i].actual_worker_amount);
              obj['编制人数'] = (data[i].preparation_worker_amount);
              list.data.push(obj);
            }
          }
        }
        // this.chartData = list;
        this.nationalStaffPositionYearChartOption = drawAnyBar(list);
        this.$nextTick(() => {
          this.$refs['national-staff-position-year-chart'].resize()
        })
      });
    },
    getExecutiveCommitteeClassifiedStatisticsCity(){
      this.$api.member
          .getExecutiveCommitteeClassifiedStatisticsCity().then((res) => {
        if (res.data.data){
          this.executiveCommitteeClassifiedStatisticsCity = res.data.data.map((item) => {
            return {
              label: item,
              value: item
            }
          });
          this.executiveCommitteeClassifiedStatisticsSelectCity = res.data.data[0];
          this.getExecutiveCommitteeClassifiedStatistics()
        }
      });
    },
    getExecutiveCommitteeClassifiedStatistics() {
      this.$api.member.getExecutiveCommitteeClassifiedStatistics({ city:
        this.executiveCommitteeClassifiedStatisticsSelectCity }).then((res) => {
        let { data } = res.data;
        if (data){
          let politicalStatusData = [];
          let educationalBackgroundData = [];
          let ageGroupData = [];
          for (let i = 0; i < data.length; i++) {
            if (data[i].political_status && data[i].political_status !== '0') {
              let getData = {
                name: data[i].political_status,
                value: data[i].political_status_percent
              }
              politicalStatusData.push(getData)
            }
            if (data[i].educational_background && data[i].educational_background !== '0') {
              let getData = {
                name: data[i].educational_background,
                value: data[i].educational_background_percent
              }
              educationalBackgroundData.push(getData)
            }
            if (data[i].age_group && data[i].age_group !== '0') {
              let getData = {
                name: data[i].age_group,
                value: data[i].age_group_percent
              }
              ageGroupData.push(getData)
            }
          }
          this.politicalStatusChartData = politicalStatusData;
          this.educationalBackgroundChartData = educationalBackgroundData;
          this.ageGroupChartData = ageGroupData;
          if(this.executiveCommitteeClassifiedStatisticsSelectType === 1){
            this.executiveCommitteeClassifiedStatisticsChartData = this.educationalBackgroundChartData
          } else if (this.executiveCommitteeClassifiedStatisticsSelectType === 2){
            this.executiveCommitteeClassifiedStatisticsChartData = this.ageGroupChartData
          } else {
            this.executiveCommitteeClassifiedStatisticsChartData = this.politicalStatusChartData
          }
        }
      });
    },
    getPerformanceEvaluationSituationYear(){
      this.$api.member
          .getPerformanceEvaluationSituationYear().then((res) => {
        if (res.data.data){
          this.performanceEvaluationSituationYear = res.data.data.map((item) => {
            return {
              label: item,
              value: item
            }
          });
          this.performanceEvaluationSituationSelectYear = res.data.data[0];
          this.getPerformanceEvaluationSituation();
        }
      });
    },
    getPerformanceEvaluationSituationIdentity(){
      this.$api.member
          .getPerformanceEvaluationSituationIdentity().then((res) => {
        if (res.data.data){
          this.performanceEvaluationSituationIdentity = res.data.data.map((item) => {
            return {
              label: item,
              value: item
            }
          });
          this.performanceEvaluationSituationSelectIdentity = res.data.data[res.data.data.length - 1];
          this.getPerformanceEvaluationSituation();
        }
      });
    },
    getPerformanceEvaluationSituation() {
      if (this.performanceEvaluationSituationSelectYear && this.performanceEvaluationSituationSelectIdentity) {
        this.$api.member.getPerformanceEvaluationSituation({
          year: this.performanceEvaluationSituationSelectYear,
          standingCommitteeIdentity: this.performanceEvaluationSituationSelectIdentity
        }).then((res) => {
          let { data } = res.data;
          if (data){
            let getChartData = [];
            for (let i = 0; i < data.length; i++) {
              let getData = {
                name: data[i].evaluation_grade,
                value: data[i].amount
              }
              getChartData.push(getData)
            }
            this.performanceEvaluationSituationChartData = getChartData;
            // this.performanceEvaluationSituationChartOption = drawPie(this.chartData);
          }
        });
      }
    },



    changeTab(item, i) {
      console.log(item, i);
      this.tabIndex = i;
      this.richTextActiveName = item.key
      this.getMemberScreenRichtext();
    },
    handleLink(index) {
      this.$emit('handleLink', {
        index,
        dataType: this.dataType,
        year: this.year,
      });
    },
    // OrganizationProfile方法
    getOrgDevData() {
      console.log(888, this.orgProfileYear);
      this.$api.member.getOrgDevelopment({ year: this.orgProfileYear }).then((res) => {
        let { data } = res.data;
        console.log(888, data);
        this.orgDev = data;
      });
    },
    getOrgInfoData(index, openTag) {
      console.log(888, index);
      if (openTag){
        this.parentName = '';
        this.searchName = '';
        this.searchNameSelectList = [];
        this.parentSelectList = [];
      }
      this.selectIndex = index;
      let administrativeLevel = '县'
      this.orgListTitle = '县级工商联信息'
      if (index === 0){
        administrativeLevel = '省'
      } else if (index === 1) {
        administrativeLevel = '市'
        this.orgListTitle = '地级市以上工商联信息'
      }
      this.$api.member.getOrgBaseInfo({
        year: this.orgProfileYear,
        administrativeLevel: administrativeLevel,
        parentName: this.parentName,
        searchName: this.searchName
      }).then((res) => {
        let { data } = res.data;
        this.orgInfoList = data;
        if (index === 0){
          if (this.orgInfoList){
            this.orgInfo = this.orgInfoList[0]
          }
          this.orgInfoShow = true;
        } else {
          if (this.orgInfoList && !this.parentName && !this.searchName){
            if (index === 1){
              this.searchNameSelectList = this.orgInfoList.map(item => {
                return {
                  label: item.organization_name,
                  value: item.organization_name
                }
              });
            } else {
              this.parentSelectList = this.orgInfoList.map(item => {
                return {
                  label: item.organization_name,
                  value: item.organization_name
                }
              });
              this.parentSelectList.forEach(item => {
                let children = [];
                for (let i = 0; i < this.orgInfoList.length; i++){
                  if (this.orgInfoList[i].children){
                    for (let j = 0; j < this.orgInfoList[i].children.length; j++){
                      if (item.value === this.orgInfoList[i].children[j].parent_organization_name) {
                        let selectData = {
                          label: this.orgInfoList[i].children[j].organization_name,
                          value: this.orgInfoList[i].children[j].organization_name
                        }
                        children.push(selectData);
                      }
                    }
                  }
                }
                item.children = children
              })
              console.log(this.parentSelectList)
            }
          }
          this.orgInfoListShow = true;
        }
      });
    },
    orgListCellClick(row,column,event,cell) {
      this.orgInfo = row;
      this.orgInfoShow = true;
    },
    getMemberDevData() {
      console.log(888, this.orgProfileYear);
      this.$api.member.getMemberDevelopment({ year: this.orgProfileYear }).then((res) => {
        let { data } = res.data;
        console.log(888, data);
        this.memberDevelopmentData = data;
      });
    },
    getMemberTopFiveData() {
      console.log(888, this.orgProfileYear);
      this.$api.member.getMemberTopFive({ year: this.orgProfileYear }).then((res) => {
        let { data } = res.data;
        console.log(888, data);
        this.memberTopFiveData = data;
      });
    },
    getMemberGrowthTopThreeData() {
      console.log(888, this.orgProfileYear);
      this.$api.member.getMemberGrowthTopThree({ year: this.orgProfileYear }).then((res) => {
        let { data } = res.data;
        console.log(888, data);
        this.memberGrowthTopThreeData = data;
      });
    },
    getOrgMemberChangeThreeYears() {
      console.log(888, this.selectMemberChangeThreeYearsCity);
      this.$api.member.getMemberChangeThreeYears({ city: this.selectMemberChangeThreeYearsCity }).then((res) => {
        let { data } = res.data;
        console.log(888, data);
        this.memberChangeThreeYearsList = data;
        this.memberChangeTabIndex = 0;
        this.getOrgMemberChangeThreeYearsChart();
      });
    },
    getOrgMemberChangeThreeYearsChart() {
      let names = ['会员数', '增幅'];
      let list = {
        yAxis: {
          names: ['单位：个', '单位：%'],
        },
        names: Array.from(names),
        data: [],
      };
      list.names = names;
      list.showLabel = true;
      if (this.memberChangeThreeYearsList) {
        for (let i = 0; i < this.memberChangeThreeYearsList.length; i++) {
          if (this.memberChangeThreeYearsList[i].this_year){
            let obj = {};
            obj['年份'] = (this.memberChangeThreeYearsList[i].this_year);
            if (this.memberChangeTabIndex === 0) {
              obj['会员数'] = this.memberChangeThreeYearsList[i].this_personal_member;
              obj['增幅'] = this.memberChangeThreeYearsList[i].personal_member_growth;
            } else if (this.memberChangeTabIndex === 1) {
              obj['会员数'] = this.memberChangeThreeYearsList[i].this_company_member;
              obj['增幅'] = this.memberChangeThreeYearsList[i].company_member_growth;
            } else if (this.memberChangeTabIndex === 2) {
              obj['会员数'] = this.memberChangeThreeYearsList[i].this_groups_member;
              obj['增幅'] = this.memberChangeThreeYearsList[i].groups_member_growth;
            }
            list.data.push(obj);
          }
        }
      }
      // this.chartData = list;
      this.memberChangeThreeYearsCityChartOption = drawBar(list);

    },
    getOrgMemberChangeThreeYearsCity() {
      console.log(888, this.orgProfileYear);
      this.$api.member.getMemberChangeThreeYearsCity().then((res) => {
        let { data } = res.data;
        console.log('city', data);
        this.memberChangeThreeYearsCity = data.map(item =>{
          return {
            label: item,
            value: item,
          }
        });
        if (data) {
          this.selectMemberChangeThreeYearsCity = data[0];
          this.getOrgMemberChangeThreeYears();
        }
      });
    },
    memberChangeTab(item, i) {
      console.log(item, i);
      this.memberChangeTabIndex = i;
      this.getOrgMemberChangeThreeYearsChart();
      // this.getData();
    },
    getCityEPerson() {
      console.log(888, this.orgProfileYear);
      console.log(888, this.cityEPersonSelectCity);
      this.$api.member.getCityEPerson({ city: this.cityEPersonSelectCity, year: this.orgProfileYear }).then((res) => {
        let { data } = res.data;
        console.log(888, data);
        this.cityEPersonList = data;
      });
    },
    getCityEPersonCity() {
      console.log(888, this.orgProfileYear);
      this.$api.member.getCityEPersonCity({year: this.orgProfileYear}).then((res) => {
        let { data } = res.data;
        console.log('city', data);
        this.cityEPersonCityList = data.map(item =>{
          return {
            label: item,
            value: item,
          }
        });
      });
    },
    getNationalFiveGood() {
      this.$api.member.getNationalFiveGood().then((res) => {
        let { data } = res.data;
        console.log(888, data);
        this.nationalFiveGoodList = data.tableData;
        this.nationalFiveGoodTotal = data.totalData;
        this.fiveGoodTabIndex = 0;
        this.showFiveTableList = this.nationalFiveGoodList;
      });
    },
    getProvincesFiveGood() {
      this.$api.member.getProvincesFiveGood().then((res) => {
        let { data } = res.data;
        console.log(888, data);
        this.provincesFiveGoodList = data.tableData;
        this.provincesFiveGoodTotal = data.totalData;
      });
    },
    fiveGoodChangeTab(item, i) {
      console.log(item, i);
      this.fiveGoodTabIndex = i;
      if (i === 0) {
        this.showFiveTableList = this.nationalFiveGoodList;
      } else if (i === 1) {
        this.showFiveTableList = this.provincesFiveGoodList;
      }
    },
    getCocChangeThreeYear() {
      console.log(888, this.selectCocChangeThreeYearsCity);
      this.$api.member.getCocChangeThreeYear({ city: this.selectCocChangeThreeYearsCity }).then((res) => {
        let { data } = res.data;
        console.log(888, data);
        this.cocChangeThreeYearsList = data;
        if (data) {
          this.getCocChangeThreeYearChart();
        }
      });
    },
    getCocChangeThreeYearCity() {
      this.$api.member.getCocChangeThreeYearCity().then((res) => {
        let { data } = res.data;
        console.log('city', data);
        this.cocChangeThreeYearsCity = data.map(item =>{
          return {
            label: item,
            value: item,
          }
        });
        if (data){
          this.selectCocChangeThreeYearsCity = data[0];
          this.getCocChangeThreeYear();
        }
      });
    },
    getCocChangeThreeYearChart() {
      let names = ['镇街商会数'];
      let list = {
        yAxis: {
          names: ['单位：个'],
        },
        names: Array.from(names),
        data: [],
      };
      list.names = names;
      list.showLabel = true;
      if (this.cocChangeThreeYearsList) {
        for (let i = 0; i < this.cocChangeThreeYearsList.length; i++) {
          if (this.cocChangeThreeYearsList[i].year){
            let obj = {};
            obj['年份'] = (this.cocChangeThreeYearsList[i].year);
            obj['镇街商会数'] = (this.cocChangeThreeYearsList[i].town_street_chambers_of_commerce_amount);
            list.data.push(obj);
          }
        }
      }
      // this.chartData = list;
      console.log(list);
      this.cocChangeThreeYearChartOption = drawOneBar(list);
    },
    showModal(index) {
      if (index === 0){
        this.showOrgDev = true;
        this.getOrgDevData();
      } else if (index === 1) {
        this.memberDevInfoShow = true;
        this.getMemberDevData();
        this.getMemberTopFiveData();
        this.getMemberGrowthTopThreeData();
        this.getOrgMemberChangeThreeYearsCity();
      } else if (index === 2 || index === 3) {
        this.workerListShow = true;
        this.getCityEPersonCity();
        this.getCityEPerson();
      } else if (index === 4) {
        this.fiveGoodListShow = true;
        this.getNationalFiveGood();
        this.getProvincesFiveGood();
      } else if (index === 5) {
        this.cocChangeThreeYearInfoShow  =true;
        this.getCocChangeThreeYearCity();
      }

      // console.log(item);
      // if (index === 0) {
      //   this.itemIndex = index;
      //   this.dialogTitle = '企业帮扶统计';
      //   if (!item.unSet) {
      //     this.search = {
      //       city: '全省',
      //       entName: null,
      //     };
      //   }
      //   this.refreshPage();
      // } else if (index < 3) {
      //   this.itemIndex = 1;
      //   this.dialogTitle = '项目管理';
      //   if (!item.unSet) {
      //     this.search = {
      //       city: '全省',
      //       entName: '',
      //     };
      //     this.refreshPage();
      //   }
      // } else return;
      // this.showDialog = true;
    },

  },
  mounted() {
  },
};
</script>

<style lang="less" scoped>
&.performance-evaluation-situation-detail .el-table {
  background: #2c4c73;
}
.el-table__expand-icon {
  color: #ffffff
}

&.national-staff-position-chart .echarts {
  width: 100%;
  height: 400px;
  > div{
    width: 100%;
  }
}

.text_211 {
  width: 902px;
  height: 39px;
  overflow-wrap: break-word;
  color: rgba(212, 189, 89, 1);
  font-size: 14px;
  font-family: MicrosoftYaHei-Bold;
  font-weight: 700;
  text-align: left;
  line-height: 16px;
}


.ml12 {
  margin-left: 12px;
}
.long-select {
  width: 150px;
  /deep/.el-select {
    width: 100%;
  }
}
.chart-bar-top{
  //.chart-box();
  width: calc((100% - 12px));;
  height: calc(100% / 3 - 5px);
  //width: 1020px;
  //height: 322px;
  margin: 0;
  display: flex;
  .chart-card-top {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    .rich-text{
      height: 240px
    }
    /deep/ .tab-list {
      margin: 5px 0 0;
      .list {
        position: unset;
      }
    }
    .card-item {
      + .card-item {
        margin-top: 25px;
        flex: 1;
        display: flex;
        flex-direction: column;
      }
    }
    .chart-ys {
      position: relative;
      /deep/ .el-cascader {
        // position: absolute;
        // top: 0;
        // left: 0;
        width: 130px;
        .el-input--suffix .el-input__inner {
          height: 28px;
          // padding-left: 44px;
          background: linear-gradient(
              0deg,
              rgba(0, 197, 250, 0.5) 0%,
              rgba(0, 197, 250, 0.48) 6%,
              rgba(0, 197, 250, 0.11) 100%
          );
          border-radius: 3px;
          border: none;
        }

        input {
          background: linear-gradient(
              0deg,
              rgba(0, 197, 250, 0.5) 0%,
              rgba(0, 197, 250, 0.48) 6%,
              rgba(0, 197, 250, 0.11) 100%
          );
          outline: none;
          border: none;
          color: #fff;
          font-size: 14px;
        }
      }
    }
    .l2-2 .card-content,
    .l2-3 .card-content {
      flex: 1;
    }
    .card-title {
      width: 100%;
      height: 36px;
      background: url('~img/market/market-card-title.png') no-repeat;
      background-size: 100% 100%;
      padding-left: 17px;
      box-sizing: border-box;
      div {
        font-family: 'AlibabaPB';
        font-weight: bold;
        font-size: 25px;
        color: #ffffff;
        line-height: 36px;
        // text-shadow: 0px 2px 8px rgba(5, 28, 55, 0.42);
        font-style: italic;
        background: linear-gradient(
            180deg,
            rgba(189, 232, 247, 1) 0%,
            rgba(191, 229, 252, 1) 20%,
            rgba(249, 253, 254, 1) 58.7646484375%
        );
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
    .card-content {
      flex: 1;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      padding-top: 2px;
      margin: -1px 1px 1px;
      background: linear-gradient(90deg, rgba(6, 17, 29, 0) 0%, rgba(58, 90, 127, 0.208) 44%, rgba(6, 17, 29, 0) 100%);
      border-radius: 4px;
      border: 1px solid;
      border-image: linear-gradient(0deg, rgba(154, 234, 255, 0.15), rgba(154, 234, 255, 0.15)) 1 1;
      border-top: none;
    }
  }
}
.chart-bar {
  //.chart-box();
  width: calc((100% - 12px));;
  height: calc(100% / 3 * 2 - 5px);
  margin: 0;
  display: flex;
  justify-content: space-between;
  .chart-card {
    //width: 100%;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    &:first-child {
      width: 100%;
    }
    .card-item {
      height: calc(100% / 2 - 25px);
      + .card-item {
        //flex: 1;
        display: flex;
        flex-direction: column;
      }
    }
    .chart-ys {
      position: relative;
      /deep/ .el-cascader {
        // position: absolute;
        // top: 0;
        // left: 0;
        width: 130px;
        .el-input--suffix .el-input__inner {
          height: 28px;
          // padding-left: 44px;
          background: linear-gradient(
            0deg,
            rgba(0, 197, 250, 0.5) 0%,
            rgba(0, 197, 250, 0.48) 6%,
            rgba(0, 197, 250, 0.11) 100%
          );
          border-radius: 3px;
          border: none;
        }

        input {
          background: linear-gradient(
            0deg,
            rgba(0, 197, 250, 0.5) 0%,
            rgba(0, 197, 250, 0.48) 6%,
            rgba(0, 197, 250, 0.11) 100%
          );
          outline: none;
          border: none;
          color: #fff;
          font-size: 14px;
        }
      }
    }
    .l2-2 .card-content,
    .l2-3 .card-content {
      flex: 1;
    }
    .card-title {
      width: 100%;
      height: 36px;
      background: url('~img/market/market-card-title.png') no-repeat;
      background-size: 100% 100%;
      padding-left: 17px;
      box-sizing: border-box;
      div {
        font-family: 'AlibabaPB';
        font-weight: bold;
        font-size: 25px;
        color: #ffffff;
        line-height: 36px;
        // text-shadow: 0px 2px 8px rgba(5, 28, 55, 0.42);
        font-style: italic;
        background: linear-gradient(
          180deg,
          rgba(189, 232, 247, 1) 0%,
          rgba(191, 229, 252, 1) 20%,
          rgba(249, 253, 254, 1) 58.7646484375%
        );
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
    .card-content {
      flex: 1;
      display: flex;
      flex-direction: column;
      padding-top: 2px;
      margin: -1px 1px 1px;
      background: linear-gradient(90deg, rgba(6, 17, 29, 0) 0%, rgba(58, 90, 127, 0.208) 44%, rgba(6, 17, 29, 0) 100%);
      border-radius: 4px;
      border: 1px solid;
      border-image: linear-gradient(0deg, rgba(154, 234, 255, 0.15), rgba(154, 234, 255, 0.15)) 1 1;
      border-top: none;
      .filter-box{
        display: flex;
        flex-direction: row;
        margin-bottom: 20px;
        .flex-center();
        justify-content: flex-end;
      }
      .chart-con {
        .chart-box {
          // width: 100%;
          height: 100%;
          overflow-x: scroll;
          display: flex;
          align-items: center;
          // justify-content: space-between;
          // padding: 0 20px;
          .bar-box {
            position: relative;
            width: 28px;
            height: 100%;
            padding: 0 8.3%;
            &:after {
              position: absolute;
              left: 50%;
              bottom: 0;
              transform: translateX(-50%);
              width: 68px;
              height: 76px;
              content: '';
              background: url('~img/market/bar-bottom.png') center center no-repeat;
              background-size: cover;
            }
            &.bar0:after {
              background: url('~img/market/bar-bottom1.png') center center no-repeat;
              background-size: cover;
            }
            &.bar1:after {
              background: url('~img/market/bar-bottom2.png') center center no-repeat;
              background-size: cover;
            }
            &.bar2:after {
              background: url('~img/market/bar-bottom3.png') center center no-repeat;
              background-size: cover;
            }
          }
          .city-box {
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
            display: flex;
            flex-direction: column;
            align-items: center;
            .num {
              font-family: Geometr706 BlkCn BT;
              font-weight: 900;
              font-size: 14px;
              color: #ffffff;
              white-space: nowrap;
              &.city-0 {
                background: linear-gradient(0deg, #f63d01 11%, #fff 60%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
              }
              &.city-1 {
                background: linear-gradient(0deg, #f48f00 11%, #fff 60%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
              }
              &.city-2 {
                background: linear-gradient(0deg, #82f40e 11%, #fff 60%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
              }
            }
            .name {
              font-family: Source Han Sans CN;
              font-weight: 400;
              font-size: 12px;
              color: #fdffff;
              white-space: nowrap;
            }
          }
          .bar-bg {
            width: 20px;
            height: 144px;
            position: absolute;
            left: 50%;
            bottom: 16px;
            transform-style: preserve-3d;
            transform: translateX(-50%) rotateX(-30deg) rotateY(-45deg);
            .bf {
              position: absolute;
              width: 100%;
              height: 100%;
              background: rgba(255, 255, 255, 0.9);
              box-sizing: border-box;
              &.front {
                transform: translateZ(10px);
                background: linear-gradient(to top, rgba(2, 26, 28, 0), rgba(24, 72, 117, 0.96));
              }
              &.right {
                transform: rotateY(90deg) translateZ(10px);
                background: linear-gradient(to bottom, rgba(24, 72, 117, 1), rgba(4, 61, 66, 0.3));
              }
              &.top {
                height: 20px;
                transform: rotateX(90deg) translateZ(10px);
                background: rgba(24, 72, 117, 0.6);
              }
            }
          }
          .cube {
            width: 20px;
            height: 100px;
            position: absolute;
            left: 50%;
            bottom: 16px;
            transform-style: preserve-3d;
            transform: translateX(-50%) rotateX(-30deg) rotateY(-45deg);
            z-index: 9;
            // animation: rotate 5s infinite linear;
            .face {
              position: absolute;
              width: 100%;
              height: 100%;
              background: rgba(255, 255, 255, 0.9);
              // border: 2px solid #ccc;
              box-sizing: border-box;

              &.front {
                transform: translateZ(10px);
                background: linear-gradient(to top, #1960b6, #3988ff);
              }
              // .back {
              //   transform: rotateY(180deg) translateZ(10px);
              //   background: linear-gradient(to right, #45a29e, #66bfa6);
              // }
              &.right {
                transform: rotateY(90deg) translateZ(10px);
                background: linear-gradient(to bottom, #072975, #1748c1);
              }
              // .left {
              //   transform: rotateY(-90deg) translateZ(10px);
              //   background: linear-gradient(to top, #ff6f61, #ffcc5c);
              // }
              &.top {
                height: 20px;
                transform: rotateX(90deg) translateZ(10px);
                background: #5dc9ff;
                // linear-gradient(to right, #ffcc5c, #ff6f61);
              }
              // .bottom {
              //   transform: rotateX(-90deg) translateZ(10px);
              //   background: linear-gradient(to left, #66bfa6, #45a29e);
              // }
            }
            &.cube-0 {
              .front {
                background: linear-gradient(to top, #d1602b, #ffaf83);
              }
              .right {
                background: linear-gradient(to bottom, #b1440e, #742111);
              }
              .top {
                background: #ff7c3a;
                // linear-gradient(to right, #ffcc5c, #ff6f61);
              }
            }
            &.cube-1 {
              .front {
                background: linear-gradient(to top, #ffc76e, #ffe6bf);
              }
              .right {
                background: linear-gradient(to bottom, #ac670d, #fed423);
              }
              .top {
                background: #ffcd7e;
              }
            }
            &.cube-2 {
              .front {
                background: linear-gradient(to top, #19a6b0, #00c67e);
              }
              .right {
                background: linear-gradient(to bottom, #07646a, #01b575);
              }
              .top {
                background: #60f9cc;
              }
            }
          }
        }
      }
    }
  }
  .wrapper {
    padding: 0 10px;
    * {
      box-sizing: border-box;
    }
  }
  .l1-1 {
    padding-top: 13px;
    padding-bottom: 28px;
    width: 100%;
    .sum-box {
      position: relative;
      width: 167px;
      height: 218px;
      padding: 28px 0;
      margin-right: 15px;
      display: flex;
      flex-direction: column;
      align-items: center;
      background: rgba(50, 98, 190, 0.11);
      border-top: 2px dashed rgba(104, 230, 255, 0.2);
      border-bottom: 2px dashed rgba(104, 230, 255, 0.2);
      .sum-i {
        position: absolute;
        width: 8px;
        height: 8px;
        border: 2px solid #68e6ff;
        &.i1 {
          left: -1px;
          top: -2px;
          border-right: none;
          border-bottom: none;
        }
        &.i2 {
          right: -1px;
          top: -2px;
          border-left: none;
          border-bottom: none;
        }
        &.i3 {
          left: -1px;
          bottom: -2px;
          border-right: none;
          border-top: none;
        }
        &.i4 {
          right: -1px;
          bottom: -2px;
          border-left: none;
          border-top: none;
        }
      }
      .sum-img {
        width: 100px;
        height: 87px;
        background: url('~img/market/market-l-sum.png') no-repeat;
        background-size: 100% 100%;
      }
      .sum-h1 {
        font-family: Alibaba PuHuiTi 2;
        font-weight: normal;
        font-size: 18px;
        color: rgba(216, 226, 255, 0.8);
        line-height: 1;
        font-style: italic;
        margin: 20px;
      }
      .sum-h2 {
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 12px;
        color: rgba(239, 240, 241, 0.6);
        line-height: 1;
        b {
          margin-right: 8px;
          font-family: YouSheTitle;
          font-weight: 400;
          font-size: 26px;
          color: #e4edf7;
        }
      }
    }
    .sum-list {
      flex: 1;
      height: 100%;
      max-height: 218px;
      overflow-y: scroll;
      .list-item {
        + .list-item {
          margin-top: 18px;
        }
        .item-top {
          &.item1 {
            .top-l span {
              color: #fb3c00;
            }
            .top-r span {
              background: linear-gradient(0deg, #f63d01 11%, #fff 90%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
          }
          &.item2 {
            .top-l span {
              color: #fa9300;
            }
            .top-r span {
              background: linear-gradient(0deg, #f48f00 11%, #fff 90%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
          }
          &.item3 {
            .top-l span {
              color: #7ffc00;
            }
            .top-r span {
              background: linear-gradient(0deg, #82f40e 11%, #fff 90%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
          }
          &.item4 {
            .top-l span {
              color: #49acff;
            }
            .top-r span {
              background: linear-gradient(0deg, #f5f8ff 11%, #fff 90%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
          }
          .top-l {
            font-family: Source Han Sans CN;
            font-weight: 500;
            font-size: 16px;
            color: #ffffff;
            span {
              font-family: Myriad Pro;
              font-weight: 400;
              font-size: 16px;
              color: #49acff;
              margin-right: 19px;
            }
          }
          .top-r {
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 12px;
            color: #d8e2ff;
            font-style: italic;
            span {
              font-family: Geometr706 BlkCn BT;
              font-weight: 900;
              font-size: 18px;
              color: #ffffff;
              font-style: italic;
              background: linear-gradient(0deg, #f5f8ff 11%, #fff 90%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              padding-right: 3px;
              margin-right: 4px;
            }
          }
        }
        .item-line {
          width: 100;
          height: 16px;
          background: rgba(16, 28, 52, 0.5);
          padding: 5px 4px;
          margin-top: 2px;
          .line {
            position: relative;
            width: 100%;
            height: 4px;
            background: #0a284a;
            border-radius: 2px;
            div {
              position: absolute;
              left: 0;
              top: -1px;
              width: 80%;
              height: 6px;
              background: linear-gradient(270deg, #51b0ff 0%, rgba(0, 120, 255, 0) 100%);
              border-radius: 2px;
              i {
                position: absolute;
                right: 0;
                top: -2px;
                width: 10px;
                height: 10px;
                display: inline-block;
                background: #e3f2ff;
                box-shadow: 0 0 7px rgba(227, 242, 255, 1);
                border-radius: 50%;
              }
            }
          }
        }
      }
    }
  }
  .l2-1 {
    .list-box {
      width: 100%;
      height: 243px;
      padding: 17px 0 8px;
      overflow-y: scroll;
      .list-item {
        width: 100%;
        height: 38px;
        border-radius: 4px;
        border: 1px solid #2b97ff;
        padding: 0 39px 0 36px;
        + .list-item {
          margin-top: 5px;
        }
        .item-l {
          font-family: Source Han Sans CN;
          font-weight: bold;
          font-size: 14px;
          color: #ffffff;
          line-height: 24px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          b {
            width: 26px;
            text-align: center;
            font-family: Geometr706 BlkCn BT;
            font-weight: 900;
            font-size: 22px;
            color: #00c9ff;
            font-style: italic;
            background: linear-gradient(0deg, #ffffff 0%, #baf0ff 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            margin-right: 22px;
          }
        }
        .item-c {
          height: 20px;
          padding: 0 13px;
          background: rgba(252, 245, 194, 0.2);
          border-radius: 2px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 12px;
          color: #fcf5c2;
          line-height: 20px;
        }
        .item-r {
          width: 80px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 14px;
          color: #dcdcdc;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          i {
            width: 12px;
            height: 12px;
            line-height: 12px;
            font-family: Geometr706 BlkCn BT;
            font-size: 20px;
            color: #dcdcdc;
            font-style: normal;
            margin-right: 11px;
            white-space: nowrap;
          }
          &.trend1 {
            background: linear-gradient(-7deg, #ffca00 0%, #ff5a00 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            i {
              background: url('~img/market/ys-up.png') center center no-repeat;
              background-size: cover;
            }
          }
          &.trend2 {
            background: linear-gradient(0deg, #19490a 0.9033203125%, #7cfa00 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            i {
              background: url('~img/market/ys-down.png') center center no-repeat;
              background-size: cover;
            }
          }
        }
      }
    }
  }
  .chart-content {
    position: relative;
    flex: 1;
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    margin-top: 5px;
    padding: 56px 0 0 17px;
    // border: NaNpx solid;
    border-image: linear-gradient(180deg, #071322, #225087) 10 10;
    background: linear-gradient(90deg, rgba(6, 17, 29, 0) 0%, rgba(58, 90, 127, 0.208) 44%, rgba(6, 17, 29, 0) 100%);
    border-radius: 4px;
  }
  /deep/ .po {
    margin: 0;
    height: 0;
    .list {
      position: absolute;
      top: 12px;
      left: 19px;
      right: unset;
    }
  }
  .chart-statistics {
    position: relative;
    background: rgba(1, 20, 48, 0.08);
    border: 2px solid rgba(#095194, 0.2);
    padding: 17px 91px 13px 29px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    i {
      position: absolute;
      top: 0;
      left: 0;
      width: 9px;
      height: 4px;
      background: #7af0fc;
      &.i2 {
        left: 14px;
        opacity: 0.6;
        &.r {
          right: 14px;
        }
      }
      &.i3 {
        left: 27px;
        opacity: 0.2;
        &.r {
          right: 27px;
        }
      }
      &.r {
        left: unset;
        right: 0;
      }
    }
    .item-title {
      position: relative;
      height: 21px;
      perspective: 50px;
      &::after {
        position: absolute;
        left: 0;
        bottom: 0;
        content: attr(data-title);
        font-size: 18px;
        font-family: Adobe Heiti Std;
        font-weight: normal;
        color: #eff0f1;
        line-height: 24px;
        padding-left: 10px;
        white-space: nowrap;
      }
      &::before {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 211px;
        height: 20px;
        background: linear-gradient(90deg, #328cbb 0%, rgba(50, 140, 187, 0.5) 10%, transparent 100%);
        content: '';
        display: block;
        transform: rotateX(24deg);
        perspective-origin: right top;
      }
    }
    .span-label,
    .span-num {
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      margin-right: 19px;
    }
    .span-num {
      color: #ff6a6a;
      margin-right: 0;
    }
    .stat-left .span-num {
      padding-left: 44px;
      font-size: 24px;
      font-weight: 900;
      color: #6acbff;
      line-height: 38px;
    }
    .span-unit {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #eff0f1;
      line-height: 29px;
      opacity: 0.6;
      margin-left: 10px;
    }
    .div-i {
      width: 16px;
      height: 16px;
      margin-right: 9px;
      display: inline-block;
      background: url('~img/commonImg/chart-stat.png') no-repeat;
      background-size: 100% 100%;
    }
    .stat-center,
    .stat-right {
      display: inline-flex;
      align-items: center;
      &.des {
        .div-i {
          transform: rotate(180deg);
        }
        .span-num {
          color: rgba(88, 236, 172, 1);
        }
      }
    }
  }
  .sub-title {
    padding: 20px 9px 13px 10px;
    font-size: 18px;
    color: #eff0f1;
    line-height: 25px;
    display: flex;
    justify-content: space-between;
    position: relative;
    &::before {
      width: 100%;
      height: 18px;
      content: ' ';
      display: block;
      position: absolute;
      bottom: 20px;
      left: 10px;
      background: linear-gradient(90deg, rgba(#0083ad, 1) 0%, rgba(#0083ad, 0) 40%);
      z-index: -1;
      transform: skewX(-40deg);
    }
    // &::after {
    //   width: 0;
    //   height: 0;
    //   content: ' ';
    //   display: block;
    //   position: absolute;
    //   position: absolute;
    //   bottom: 20px;
    //   left: 10px;
    //   border: 20px solid transparent;
    //   border-left-color: #000;
    // }
    span {
      padding-left: 20px;
    }
    div {
      display: inline-flex;
      line-height: 1;
      align-items: center;
    }
    #btn-link {
      margin-left: 12px;
    }
  }
  .chart-con {
    flex: 1;
    height: 198px;
    /deep/ .echarts > div {
      max-height: 100%;
      canvas {
        height: 100% !important;
      }
    }
  }
  .left-bottom {
    display: flex;
    > div {
      width: calc(50% - 13px);
      &:first-of-type {
        margin-right: 26px;
      }
      /deep/ .title {
        white-space: nowrap;
        width: 100%;
        #btn-link {
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
        }
      }
      /deep/ .flex-between {
        height: 52px;
      }
    }
  }
}
/deep/ .ele-dialog {
  z-index: 9999;
  .sub-title {
    padding: 20px 9px 18px 10px;
    font-size: 22px;
    color: #eff0f1;
    line-height: 25px;
    display: flex;
    justify-content: space-between;
    position: relative;
    &::before {
      width: 100%;
      height: 18px;
      content: ' ';
      display: block;
      position: absolute;
      bottom: 20px;
      left: 10px;
      background: linear-gradient(90deg, rgba(#0083ad, 1) 0%, rgba(#0083ad, 0) 40%);
      z-index: -1;
      transform: skewX(-40deg);
    }
    // &::after {
    //   width: 0;
    //   height: 0;
    //   content: ' ';
    //   display: block;
    //   position: absolute;
    //   position: absolute;
    //   bottom: 20px;
    //   left: 10px;
    //   border: 20px solid transparent;
    //   border-left-color: #000;
    // }
    span {
      padding-left: 20px;
    }
    div {
      display: inline-flex;
      line-height: 1;
      align-items: center;
    }
    #btn-link {
      margin-left: 12px;
    }
  }
  .item-label {
    font-family: Microsoft YaHei;
    font-weight: 400;
    font-size: 22px;
    color: #ffffff;
    line-height: 1;
    text-shadow: 1px 2px 0px rgba(17, 20, 22, 0.22);
    font-style: italic;
    b {
      font-size: 26px;
    }
    .comment-font {
      font-family: Microsoft YaHei;
      font-weight: 400;
      font-size: 16px;
      color: #CE5E03FF;
      line-height: 1;
      text-shadow: 1px 2px 0px rgba(17, 20, 22, 0.22);
      font-style: italic;
    }
  }
  .item-value {
    white-space: nowrap;
    line-height: 1;
    margin-top: 7px;
    b {
      font-family: Geometr706 BlkCn BT;
      font-weight: 900;
      font-size: 22px;
      color: #ffffff;
      font-style: italic;
      background: linear-gradient(0deg, #8bb4d0 0%, rgba(255, 255, 255, 1) 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      padding-right: 3px;
    }
    span {
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #eff0f1;
      // line-height: 29px;
      opacity: 0.6;
      margin-left: 12px;
      white-space: nowrap;
    }
  }
  &.info-modal {
    .item-title {
      position: relative;
      perspective: 100px;
      margin-bottom: 28px;
      height: 25px;
      &::after {
        position: absolute;
        left: 0;
        bottom: 0;
        content: attr(data-title);
        font-size: 18px;
        font-family: Adobe Heiti Std;
        font-weight: normal;
        color: #eff0f1;
        line-height: 24px;
        padding-left: 10px;
      }
      &.YouSheTitle::after {
        font-family: 'YouSheTitle';
        font-weight: 400;
        font-size: 26px;
      }
      &::before {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 20px;
        background: linear-gradient(90deg, #328cbb 0%, rgba(50, 140, 187, 0.5) 10%, transparent 100%);
        content: '';
        display: block;
        transform: rotateX(8deg);
        perspective-origin: right top;
      }
    }

    .item-content {
      width: 100%;
      height: auto !important;
      align-items: flex-start;
      box-sizing: border-box;
      border-image: linear-gradient(180deg, #071322, #225087) 10 10;
      // background: linear-gradient(
      //   90deg,
      //   rgba(38, 69, 103, 0.4) 0%,
      //   rgba(61, 110, 167, 0.4) 47%,
      //   rgba(38, 69, 103, 0.4) 100%
      // );
      border-radius: 4px;
      margin-bottom: 41px;
      padding: 23px 20px 31px 41px;
      ul.content-ul {
        padding: 0;
        margin: 0;
        list-style: none;
        max-width: calc(100% / 3);

        + ul {
          position: relative;
          padding-left: 43px;
          &::before {
            position: absolute;
            left: 0;
            top: 0;
            width: 2px;
            height: 100%;
            background: #2c4c73;
            box-shadow: 1px 0px 2px 0px rgba(20, 34, 51, 0.5);
            content: '';
            display: inline-block;
          }
        }
        li {
          display: flex;
        }
        .li-label {
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #dcdcdc;
          line-height: 30px;
          margin-right: 22px;
          text-wrap: nowrap;
        }
        .li-value {
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #ffffff;
          line-height: 30px;
        }
      }
    }
  }

  &.company-profile .el-dialog {
    width: 2144px;
    height: 806px;
    .el-dialog__body {
      padding: 0;
      height: calc(100% - 55px);
      .item-content {
        // padding: 0;
      }
    }
  }
  &.org-dev .el-dialog {
    height: calc(100% - 1200px);
    .el-dialog__body {
      height: calc(100% - 220px);
    }
    .a-class {
      font-family: Microsoft YaHei;
      font-weight: 400;
      font-size: 22px;
      color: #ffffff;
    }
  }

  &.org-info .el-row {
    padding-top: 30px;
  }
  .el-table {
    background: #2c4c73;
  }
  .el-table__expand-icon {
    color: #ffffff
  }
  &.member-dev .echarts {
    padding-top: 10px;
    width: 100%;
    height: 250px;
  }
  &.member-dev .flex-between {
    display: flex;
    align-items: center;
    justify-content: unset;
  }
  &.five-good .tab-item {
    font-size: 22px;
  }
  &.five-good .tab-list .list{
    position: relative;
  }
  &.coc-change-three-year .echarts {
    width: 100%;
    height: 300px;
  }
  .flex-between {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
</style>
